import cx from 'classnames'
import styles from './ActivitiesList.module.scss'
import AdventureCardPlaceholder from '../adventures/AdventureCardPlaceholder'
import useCoursesList from '../dive-center/hooks/useCoursesList'
import { Fragment, useState, useEffect } from 'react'
import NoResults from '../dive-center/NoResults'
import { CourseCardDsl } from '../dive-center/CardsDsl'
import handleViewport from 'react-in-viewport'
import Proptypes from 'prop-types'

const PaginationButton = ({ onClick, active, children }) => {
  return (
    <button
      type='button'
      onClick={onClick}
      className={cx({
        [styles.active]: active,
      })}
      aria-current={active ? 'page' : undefined}
    >
      {children}
    </button>
  )
}

const PrevButton = ({ onClick, disabled }) => (
  <button
    type='button'
    onClick={onClick}
    disabled={disabled}
    className={cx(styles.navButton, styles.prevButton, {
      [styles.disabled]: disabled,
    })}
    aria-label='previous page'
  >
    <span aria-hidden='true'>‹</span>
  </button>
)

const NextButton = ({ onClick, disabled }) => (
  <button
    type='button'
    onClick={onClick}
    disabled={disabled}
    className={cx(styles.navButton, styles.nextButton, {
      [styles.disabled]: disabled,
    })}
    aria-label='next page'
  >
    <span aria-hidden='true'>›</span>
  </button>
)

function CoursesSlider({
  inViewport,
  enterCount,
  forwardedRef,
  diveCenterId,
  isWidget,
  wechatQr,
}) {
  const isMobile = window.innerWidth < 768
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = isMobile ? 1 : 4

  const {
    courses,
    params,
    total,
    isLoading,
    setParams,
    isShowPlaceholder,
    isNextPageAvailable,
  } = useCoursesList(diveCenterId, inViewport, enterCount)

  // Оновлюємо параметри при зміні сторінки
  useEffect(() => {
    setParams({ page: currentPage, pageSize: itemsPerPage })
  }, [currentPage])

  const placeholderItems = [...new Array(itemsPerPage)]
  const totalPages = Math.ceil(total / itemsPerPage)

  const handlePrevPage = () => {
    if(currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }

  const handleNextPage = () => {
    if(currentPage < totalPages && isNextPageAvailable) {
      setCurrentPage(currentPage + 1)
    }
  }

  if(!inViewport && enterCount === 0) {
    return <div
      className={cx('featured-slider', styles.featuredSlider)}
      ref={forwardedRef}
    >

      <div className={styles.sliderContainer}>

        <div className={cx(styles.cardsContainer, {
          'placeholder-animation': isLoading,
        })}>
          {placeholderItems.map((_, i) => {
            return <AdventureCardPlaceholder key={i} />
          })}
        </div>
      </div>
    </div>
  }

  const isNoResults = !courses.length && !isLoading
  console.log(courses.length, isLoading, isNoResults)

  return <div
    className={cx('featured-slider', styles.featuredSlider)}
    ref={forwardedRef}
  >
    <div id='social-items' className={styles.sliderContainer}>
      <Fragment>
        {isNoResults ? (
          <NoResults />
        ) : (
          <Fragment>
            {totalPages > 1 && params.page !== 1 && (
              <PrevButton
                onClick={handlePrevPage}
                disabled={currentPage === 1}
              />
            )}

            <div className={cx(styles.cardsContainer, {
              'placeholder-animation': isLoading,
            })}>
              {isLoading
                ? placeholderItems.map((_, i) => {
                  return <AdventureCardPlaceholder key={i} />
                })
                : courses.map((trip, index) => (
                  <CourseCardDsl
                    trip={trip}
                    isWidget={isWidget}
                    key={`${trip.title}${index}`}
                    wechatQr={wechatQr}
                  />
                ))
              }
            </div>

            {totalPages > 1 && isNextPageAvailable && (
              <NextButton
                onClick={handleNextPage}
                disabled={!isNextPageAvailable || currentPage === totalPages}
              />
            )}

            {totalPages > 1 && !isMobile && (
              <div className={styles.paginationDots}>
                {Array.from({ length: totalPages }).map((_, index) => (
                  <PaginationButton
                    key={index}
                    active={currentPage === index + 1}
                    onClick={() => setCurrentPage(index + 1)}
                  >
                    <span className={styles.dot} />
                  </PaginationButton>
                ))}
              </div>
            )}
          </Fragment>
        )}
      </Fragment>
    </div>
  </div>
}

CoursesSlider.propTypes = {
  inViewport: Proptypes.bool,
  enterCount: Proptypes.number,
  forwardedRef: Proptypes.node,
  diveCenterId: Proptypes.number,
  isWidget: Proptypes.bool,
  wechatQr: Proptypes.string,
}

PaginationButton.propTypes = {
  onClick: Proptypes.func,
  active: Proptypes.bool,
  children: Proptypes.node,
}

PrevButton.propTypes = {
  onClick: Proptypes.func,
  disabled: Proptypes.bool,
}

NextButton.propTypes = {
  onClick: Proptypes.func,
  disabled: Proptypes.bool,
}

export const CoursesSliderLazyLoad = handleViewport(CoursesSlider, {}, { disconnectOnLeave: true })
